import * as Sentry from '@sentry/vue'
import { pinia } from '@/modules/pinia'

import { useAuthenticationStore } from '@/stores/authentication'
import { useCalculationStore } from '@/stores/calculation'
import { storeToRefs } from 'pinia'

const authStore = useAuthenticationStore(pinia)

export const useSentryFeedback = () => {
  const feedback = Sentry.getFeedback()
  if (!feedback) return

  let widget: ReturnType<typeof feedback.createWidget> | null = null

  const isAuthenticated = () => {
    return authStore.user !== null && authStore.user !== undefined
  }

  const updateFeedbackWidget = () => {
    if (isAuthenticated() && !widget) {
      widget = feedback.createWidget()
      widget.appendToDom()
      if (authStore.user?.email) {
        Sentry.setUser({
          username: authStore.user.first_name ?? '',
          email: authStore.user.email ?? ''
        })
      }
    } else if (!isAuthenticated() && widget) {
      widget.removeFromDom()
      widget = null
      Sentry.setUser(null)
    }
  }
  updateFeedbackWidget()
  authStore.$subscribe(updateFeedbackWidget)

  const calculationStore = useCalculationStore(pinia)
  const { createDialog } = storeToRefs(calculationStore)
  calculationStore.$subscribe(() => {
    const feedbackActor = document.getElementById('sentry-feedback')
    feedbackActor?.style.setProperty('--actor-inset', createDialog.value ? 'auto 0 40px auto' : '')
  })
}